import Vue from 'vue'
import Toasted from 'vue-toasted'
import store from '../../vue/store'
import clientLocaleBundle from './locales'
import clientConfigurationBundle from './config'
import AdvProductCard from './AdvProductCard.vue'
import config from '../../vue/config/configPlugin'
import locale from '../../vue/locales/localePlugin'
import AdvCartGiftList from './AdvCartGiftList'
import AdvButtonViewBuy from './AdvButtonViewBuy'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import AdvCartProductList from './AdvCartProductList.vue'
import InitialData from '../../vue/data-components/InitialData.vue'
import AdvMinicartGiftChoiceModal from './AdvMinicartGiftChoiceModal'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import jqueryVueBridgePlugin from '../../vue/plugins/jqueryVueBridgePlugin'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture'
import CookieModal from './cookies/components/CookieModal.vue'
import CookieSettingsButton from './cookies/components/CookieSettingsButton.vue'
import AdvCartProductCustomizationEditor from './cartProductCustomizations/AdvCartProductCustomizationEditor'
import AdvCartProductCustomizationDisplayValues
from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AfterAddToCartModal from './AfterAddToCartModal.vue'
import ProductPriceChartModal from './product/ProductPriceChartModal.vue'
import AdvButtonViewBuyPicker from './AdvButtonViewBuyPicker.vue'
import AdvCardButtonViewBuyPicker from './AdvCardButtonViewBuyPicker.vue'
import AdvCartDeliveryInfo from './AdvCartDeliveryInfo'
import AdvProductGalleryWithVideo from './AdvProductGalleryWithVideo.vue'
import PreCheckoutSidebar from './PreCheckoutSidebar.vue'

// --- Stale code-split chunk recovery -----------------------------------------
// Runtime code-split chunks are emitted with a content hash in their filename
// (see chunkFilename in webpack.mix.front.js). Across a deploy a chunk's name
// changes, but a browser/CDN holding stale HTML may request the old name and
// 404. On such a failure we reload ONCE so the browser re-fetches the fresh
// HTML + manifest + chunks. The one-shot is guarded by a sessionStorage flag
// that survives the reload, so a genuinely-missing chunk can't loop forever.
const RELOAD_KEY = 'adv:chunk-reload'
let reloadScheduled = false

function isChunkLoadError (err) {
  const msg = (err && (err.message || err.toString())) || ''
  return (err && err.name === 'ChunkLoadError') ||
    /loading (css )?chunk \S+ failed|failed to fetch dynamically imported module/i.test(msg)
}

function clearReloadGuard () {
  try { sessionStorage.removeItem(RELOAD_KEY) } catch (e) {}
}

function handleChunkError (err) {
  if (!isChunkLoadError(err)) throw err // not ours — rethrow
  if (reloadScheduled) return new Promise(() => {}) // a reload is already coming this page-life
  let alreadyTried = false
  try { alreadyTried = !!sessionStorage.getItem(RELOAD_KEY) } catch (e) {}
  if (alreadyTried) throw err // already reloaded once this session — give up, no loop
  try { sessionStorage.setItem(RELOAD_KEY, '1') } catch (e) {}
  reloadScheduled = true
  window.location.reload()
  return new Promise(() => {}) // never resolve → no error state pre-reload
}

// Wrap a dynamic-import factory: a successful load re-arms the guard (so a
// future deploy gets its own one-shot reload); a stale-chunk failure triggers
// the reload.
const lazyChunk = (factory) => () => factory()
  .then((mod) => { clearReloadGuard(); return mod })
  .catch(handleChunkError)

// Backstop for any chunk rejection that escapes the wrapper. Swallow the
// rethrow so it never reaches the console / error tracker as a fresh error.
window.addEventListener('unhandledrejection', (e) => {
  if (isChunkLoadError(e && e.reason)) {
    try { handleChunkError(e.reason) } catch (_) {}
  }
})
// -----------------------------------------------------------------------------

const CheckoutPage = lazyChunk(() => import(/* webpackChunkName: "checkout-page" */ './CheckoutPage.vue'))
const googleMapPartners = lazyChunk(() => import(/* webpackChunkName: "google-map-partners" */ './googleMaps/components/googleMapPartners.vue'))
const AllListingFilters = lazyChunk(() => import(/* webpackChunkName: "all-listing-filters" */ './AllListingFilters.vue'))
const AdvListingUsedFilters = lazyChunk(() => import(/* webpackChunkName: "adv-listing-used-filters" */ './AdvListingUsedFilters.vue'))
const AdvButtonViewBuyCombo = lazyChunk(() => import(/* webpackChunkName: "adv-button-view-buy-combo" */ './AdvButtonViewBuyCombo.vue'))
const AdvProductGallery = lazyChunk(() => import(/* webpackChunkName: "adv-product-gallery" */ './AdvProductGallery.vue'))
const GiftCardPage = lazyChunk(() => import(/* webpackChunkName: "gift-card-page" */ './giftCards/GiftCardPage.vue'))
const HomeStreamSlider = lazyChunk(() => import(/* webpackChunkName: "home-stream-slider" */ './streamSlider/HomeStreamSlider.vue'))
const StreamSlide = lazyChunk(() => import(/* webpackChunkName: "stream-slide" */ './streamSlider/StreamSlide.vue'))
const Reels = lazyChunk(() => import(/* webpackChunkName: "reels" */ './streamSlider/Reels.vue'))

// import ViberForm from './ViberForm.vue'
// import ViberSignOut from './ViberSignOut.vue'
// import BirthdayForm from './BirthdayForm'

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)
Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })
Vue.use(jqueryVueBridgePlugin)

window.Vue = new Vue({
  el: '#app',
  store,
  config,
  locale,
  jqueryVueBridgePlugin,
  components: {
    InitialData,
    LiveProductData,
    CookieModal,
    CookieSettingsButton,
    AdvProductCard,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvMinicartGiftChoiceModal,
    AdvHtmlPicture,
    AdvCartProductCustomizationEditor,
    AdvCartProductCustomizationDisplayValues,
    AdvProductGalleryWithVideo,
    AdvCartDeliveryInfo,
    PreCheckoutSidebar,
    AfterAddToCartModal,
    ProductPriceChartModal,
    AdvButtonViewBuyPicker,
    AdvCardButtonViewBuyPicker,
    HomeStreamSlider,
    StreamSlide,
    AdvProductGallery,
    AdvButtonViewBuyCombo,
    AdvListingUsedFilters,
    AllListingFilters,
    CheckoutPage,
    googleMapPartners,
    GiftCardPage,
    Reels
    // ViberForm,
    // ViberSignOut
    // BirthdayForm
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    cartProductsTotalPoints () {
      return store.getters.getCartProductsTotalPoints
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal () {
      return store.getters.cartProductWeightTotal
    },
    cartDefaultCouponCode () {
      return store.getters.getDefaultCouponCode
    },
    cartDefaultCouponDiscount () {
      return parseFloat(store.getters.getDefaultCouponDiscount).toFixed(2)
    },
    cartDefaultCouponName () {
      return store.getters.getDefaultCouponName
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    },
    cartHasGifts () {
      return Object.keys(store.getters.giftChoicesGroupedByGiftId).length
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
})
